import * as ol from 'openlayers'
import { DataTheme } from 'src/Enums'
import { GeoLayer, AbstractLayer, AbstractLayerOptions } from './Layer'
import { layerCopyrights, LayerDescription, LayerGroup, LayerParamsObject, LayerType } from './LayerRegistry'
import legendImage from '../../img/legend_seabed_sediments.png'
import { ContextTag } from '../wiki/Wiki'

/**
 * Map layer class for the Seabed Sediments WMS source from GEUS.
 */
class SeabedSedimentsLayer extends AbstractLayer implements GeoLayer {
  static readonly defaultParams: LayerParamsObject = {
    opacity: 0.5
  }

  constructor (options: any) {
    const defaultOptions: AbstractLayerOptions = {
      layerType: LayerType.SEABED_SEDIMENTS,
      enabled: true,
      minZoom: 7,
      zIndex: 3
    }
    super({ ...defaultOptions, ...options })

    let { opacity } = options.params
    opacity = opacity === undefined ? SeabedSedimentsLayer.defaultParams.opacity : opacity

    this.olLayer = new ol.layer.Image({
      visible: this.enabled,
      opacity: opacity,
      source: new ol.source.ImageWMS({
        url: 'http://data.geus.dk/arcgis/services/Denmark/Havbundssediment/MapServer/WMSServer?',
        params: {
          layers: 'Seabed_sediment'
        },
        projection: new ol.proj.Projection({
          code: 'EPSG:25832'
        }),
      })
    })
  }

  static describe (): LayerDescription {
    return {
      type: LayerType.SEABED_SEDIMENTS,
      name: 'map.layer.seabedsediments',
      group: LayerGroup.NEAR_TERRAIN,
      contextTags: [
        ContextTag.SEABED_SEDIMENTS
      ],
      themes: Object.values(DataTheme),
      capabilitiesUrl: '',
      legendEnabled: true,
      imageLegend: {
        legendImage: legendImage,
        imageWidth: 180,
        legendTextId: 'layerpicker.legend.text.seabedsediments'
      },
      opacityEnabled: true,
      layerCopyright: layerCopyrights.Geus
    }
  }
}

export default SeabedSedimentsLayer
